import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import NotFound from '@/components/404.vue';
import ServerError from '@/components/500.vue';
import Unauthorized from '@/components/401.vue';
import Forbidden from '@/components/403.vue';
import ErrorPage from '@/components/error-page.vue';
import Login from '@/components/Login.vue';
import Layout from '@/components/Layout.vue';
import tempRoutes from './tempRoutes';
import systemRoutes from './systemRoutes';
import { ROUTES } from '@/config/constants';

const routes: Array<RouteRecordRaw> = [
    ...tempRoutes,
    ...systemRoutes,
    {
        path: '/',
        name: 'Home',
        component: Layout,
        meta: { requiresAuth: true }
    },
    {
        path: `/${ROUTES.LOGIN}`,
        name: 'Login',
        component: Login
    },
    {
        path: `/${ROUTES.SERVER_ERROR}`,
        name: '500',
        component: ServerError
    },
    {
        path: `/${ROUTES.ERROR_PAGE}`,
        name: 'ErrorPage',
        component: ErrorPage
    },
    {
        path: `/${ROUTES.TOKEN_EXPIRED}`,
        name: '401',
        component: Unauthorized 
    },
    {
        path: `/${ROUTES.FORBIDDEN}`,
        name: '403',
        component: Forbidden
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('token'); // 检查是否有 token

    // 如果目标页面需要认证
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            // 未登录，重定向到登录页面
            next('/login');
        } else {
            // 已登录，允许进入
            next();
        }
    } else {
        // 如果不需要认证，允许访问
        next();
    }
});

export default router;